import React from 'react'
import Link from '../Link'
import Layout from '../Layout'
import Hero, { HeroTitle } from '../Hero'
import styled from 'styled-components'
import Query from './Query'
import {
  FaYoutube,
  FaLinkedinIn,
  FaGithub,
  FaFacebookF,
  FaTwitter,
  FaInstagram
} from 'react-icons/fa'
import { IoLogoTiktok } from 'react-icons/io5'
import { ThemeConsumer } from '../../state'
import FullWidthSection from '../FullWidthSection'
import Image from '../Image'
import Markdown from '../Markdown'
import Navigation from './Navigation'

const HeroSocialLinks = styled.ul`
  margin: 0;
  list-style: none;
  padding-top: 6rem;
  font-size: 3.6rem;
  text-align: center;

  li {
    display: inline-block;
    padding: 0 3rem;
  }

  a {
    color: ${({ theme }) => theme.colors.secondaryText};

    &:hover {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`

const PressContainer = styled.div`
  list-style: none;
  padding: 3rem 0;

  p {
    text-align: center;
    //text-transform: uppercase;
  }

  a {
    display: block;
  }

  img {
    width: 100%;
  }
`

const PressImages = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const PressImage = styled.div`
  margin-top: 2rem;
  flex: 1 0 ${100 / 8}%;
  max-width: ${100 / 8}%;

  @media screen and (max-width: 800px) {
    flex: 1 0 ${100 / 4}%;
    max-width: ${100 / 4}%;
  }
`

const ContentSection = styled.div`
  text-align: left;
  padding: 6rem 0;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}rem` : '100%')};
  display: block;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 1100px) {
    display: block;
  }
`

// const DividedContent = styled.div`
//   padding: 0 2rem;
//   flex: ${({ flex }) => flex || 1};
//   display: ${({ displayFlex }) => displayFlex ? 'flex' : 'block'};
//   @media screen and (max-width: 700px) {
//     display: block;
//   }
// `

export default () => (
  <ThemeConsumer>
    {({ theme }) => (
      <Query
        render={(content) => (
          <Layout>
            <Hero>
              <HeroTitle useH1>{content.title}</HeroTitle>
            </Hero>
            <Navigation />
            <ContentSection maxWidth={70}>
              <Markdown source={content.hero_body} />
            </ContentSection>
            <FullWidthSection background={theme.colors.primaryHighlight}>
              <ContentSection maxWidth={70}>
                <h2>{content.cascading_disruption.title}</h2>
                <Markdown source={content.cascading_disruption.body_text} />
              </ContentSection>
            </FullWidthSection>
            <ContentSection maxWidth={70}>
              <h2>{content.mission.title}</h2>
              <Markdown source={content.mission.body_text} />
            </ContentSection>
            <FullWidthSection background={theme.colors.primaryHighlight}>
              <ContentSection maxWidth={70}>
                <h2>{content.the_company.title}</h2>
                <Markdown source={content.the_company.body_text} />
              </ContentSection>
            </FullWidthSection>
            <FullWidthSection background={theme.colors.textInverted}>
              <PressContainer>
                <p>{content.featured_in_press}</p>
                <Link
                  href="/press/"
                  tracking={{ label: 'about_page_press_banner' }}
                >
                  <PressImages>
                    <PressImage>
                      <Image
                        size={250}
                        src={theme.images.press.Forbes}
                        alt="Forbes"
                      />
                    </PressImage>
                    <PressImage>
                      <Image
                        size={250}
                        src={theme.images.press.TheTimes}
                        alt="The Times"
                      />
                    </PressImage>
                    <PressImage>
                      <Image
                        size={250}
                        src={theme.images.press.Bloomberg}
                        alt="Bloomberg"
                      />
                    </PressImage>
                    <PressImage>
                      <Image
                        size={250}
                        src={theme.images.press.Nasdaq}
                        alt="Nasdaq"
                      />
                    </PressImage>
                    <PressImage>
                      <Image
                        size={250}
                        src={theme.images.press.FinancialTimes}
                        alt="Financial Times"
                      />
                    </PressImage>
                    <PressImage>
                      <Image
                        size={250}
                        src={theme.images.press.BusinessInsider}
                        alt="Business Insider"
                      />
                    </PressImage>
                    <PressImage>
                      <Image
                        size={250}
                        src={theme.images.press.CoinDesk}
                        alt="CoinDesk"
                      />
                    </PressImage>
                    <PressImage>
                      <Image
                        size={250}
                        src={theme.images.press.ABCNews}
                        alt="ABC News"
                      />
                    </PressImage>
                  </PressImages>
                </Link>
              </PressContainer>
            </FullWidthSection>
            <ContentSection>
              <HeroSocialLinks>
                <li>
                  <Link
                    href={content.hero_social.twitter_href}
                    tracking={{ label: 'about_page_hero_twitter' }}
                    target="_blank"
                    rel="noopener"
                  >
                    <FaTwitter />
                  </Link>
                </li>
                <li>
                  <Link
                    href={content.hero_social.facebook_href}
                    tracking={{ label: 'about_page_hero_facebook' }}
                    target="_blank"
                    rel="noopener"
                  >
                    <FaFacebookF />
                  </Link>
                </li>
                <li>
                  <Link
                    href={content.hero_social.github_href}
                    tracking={{ label: 'about_page_hero_github' }}
                    target="_blank"
                    rel="noopener"
                  >
                    <FaGithub />
                  </Link>
                </li>
                <li>
                  <Link
                    href={content.hero_social.linkedin_href}
                    tracking={{ label: 'about_page_hero_linkedin' }}
                    target="_blank"
                    rel="noopener"
                  >
                    <FaLinkedinIn />
                  </Link>
                </li>
                <li>
                  <Link
                    href={content.hero_social.youtube_href}
                    tracking={{ label: 'about_page_hero_youtube' }}
                    target="_blank"
                    rel="noopener"
                  >
                    <FaYoutube />
                  </Link>
                </li>
                <li>
                  <Link
                    href={content.hero_social.tiktok_href}
                    tracking={{ label: 'about_page_hero_tiktok' }}
                    target="_blank"
                    rel="noopener"
                  >
                    <IoLogoTiktok />
                  </Link>
                </li>
                <li>
                  <Link
                    href={content.hero_social.instagram_href}
                    tracking={{ label: 'about_page_hero_instagram' }}
                    target="_blank"
                    rel="noopener"
                  >
                    <FaInstagram />
                  </Link>
                </li>
              </HeroSocialLinks>
            </ContentSection>
          </Layout>
        )}
      />
    )}
  </ThemeConsumer>
)
